export const SignatureTypes = {
    Drawing: "drawing",
    Text: "text",
    Image: "image"
}